import Cookies from 'js-cookie';

import apiRequest from '@/js/helpers/apiRequest';
import formattedError from '@/js/utils/formattedError';

import { ERROR_CALL_ORDER } from '@/js/utils/constants/constErrorsCode';

const send = (data, personType, method) => new Promise((resolve, reject) => {
  const isEntity = personType === 'entity';
  const userName = data.name || '';
  const [lastName, name, secondName] = userName.split(' ');
  const mnogoRuCard = Cookies.get('BITRIX_SM_MNOGORU_CARD');

  const postData = {
    EMAIL: data.email,
    LAST_NAME: data.lastName || lastName,
    NAME: data.firstName || name,
    SECOND_NAME: data.secondName || secondName,
    PERSONAL_PHONE: data.phone,
    PERSONAL_MOBILE: data.phoneMobile,
    AUTHORIZE: 'Y',
    PERSON_TYPE_ID: 1,
    BOOK24_ORDER_REGISTER: 'Y',
  };

  if (data.userId) {
    Object.assign(postData, { ID: data.userId });
  }

  if (mnogoRuCard) {
    Object.assign(postData, { MNOGORU_CARD: mnogoRuCard });
  }

  if (data.gender) {
    Object.assign(postData, { PERSONAL_GENDER: data.gender });
  }

  if (data.birthday) {
    Object.assign(postData, { PERSONAL_BIRTHDAY: data.birthday });
  }

  if (data.captchaAction) {
    Object.assign(postData, { captchaAction: data.captchaAction });
  }

  if (data.captchaToken) {
    Object.assign(postData, { captchaToken: data.captchaToken });
  }

  if (data.captchaVersion) {
    Object.assign(postData, { captchaVersion: data.captchaVersion });
  }

  if (data.unsubscribed) {
    Object.assign(postData, { unsubscribed: data.unsubscribed });
  }

  if (isEntity) {
    Object.assign(postData, {
      PERSON_TYPE_ID: 2,
      UF_INN: data.inn,
      UF_NAZ: data.organizationName,
      UF_UR_ADDRESS: data.legalAddress,
      UF_KPP: data.kpp,
      UF_BIK: data.bik,
      UF_KOR: data.correspondentAccount,
      UF_CHECKING_ACCOUNT: data.checkingAccount,
      UF_NAIM: data.bankName,
    });
  }

  return apiRequest[method.toLowerCase()]('/user/', postData)
    .then((res) => {
      resolve(method === 'put' ? res.DATA.USER : res.data.USER);
    })
    .catch((error) => {
      if (error.status) {
        const errors = formattedError(error.data, ERROR_CALL_ORDER);
        // знаем точно что ожидаем одну ошибку
        const [firstError] = errors;
        return reject(firstError);
      }
      return reject(error);
    });
});

function post(...args) {
  return send(...args, 'post');
}

function put(...args) {
  return send(...args, 'put');
}

export default { post, put };
